var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sensible Daten",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38095 0.549438C1.06599 0.549438 0 1.61543 0 2.93039V25.5494C0 39.3566 11.1929 50.5494 25 50.5494C38.8071 50.5494 50 39.3566 50 25.5494C50 11.7423 38.8071 0.549438 25 0.549438H2.38095ZM17.0245 20.4604C17.0245 16.8544 20.1346 13.9424 24 13.9424C27.8653 13.9424 30.9754 16.8544 30.9754 20.4604V23.0692C32.2562 23.1867 32.9285 24.1799 32.9285 25.3766V33.9563C32.9285 35.2329 31.7949 36.2638 30.3912 36.2638H17.6087C16.205 36.2638 15.0714 35.2329 15.0714 33.9563V25.3766C15.0714 24.1799 15.7437 23.1947 17.0245 23.0771V23.0692V20.4604ZM28.4642 20.4762C28.4642 18.2562 26.4736 16.4719 24 16.4719C21.5263 16.4719 19.5357 18.2562 19.5357 20.4762V23.0692H28.4642V20.4762ZM25.9531 28.144C25.9531 27.1631 25.0786 26.3678 24 26.3678C22.9213 26.3678 22.0468 27.1631 22.0468 28.144C22.0468 28.7676 22.4017 29.3179 22.9362 29.6348C22.907 29.7256 22.8839 29.8206 22.8839 29.9202V31.9502C22.8839 32.5125 23.3817 32.9651 24 32.9651C24.6183 32.9651 25.116 32.5125 25.116 31.9502V29.9202C25.116 29.8206 25.0929 29.7256 25.0637 29.6348C25.5983 29.3179 25.9531 28.7676 25.9531 28.144Z",
    fill: "#F3F0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolLock);
export default __webpack_public_path__ + "static/media/symbol-lock.3c2d126a9fb97c3d852f14b11497026e.svg";
export { ForwardRef as ReactComponent };